import { FADE_IN_KEYFRAMES } from '@modules/common/constants';
import { WisdomLogoIcon } from '@modules/oracle/components/WisdomLogoIcon';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { trackWisdomEvents } from '@modules/oracle/utils';
import { Box, Stack, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetUser } from 'v2/core/services/user';
import { AskOracleInput } from '../AskOracleInput';
import { WisdomCapabilities } from './WisdomCapabilities';

export function OracleEmptySearchViewV2() {
  const location = useLocation();
  const { firstName } = useGetUser();
  const [question, setQuestion] = useState('');
  const sessionID = useOracleSearchStore(({ data }) => data.sessionID);
  const askOracleInputRef = useRef<HTMLInputElement>(null);
  const isRedirectedFromOnboarding = location.state?.isRedirectedFromOnboarding;

  return (
    <Stack
      component={Box}
      sx={{
        pt: 4,
        height: '100%',
        width: '100%',
        maxWidth: '900px',
        margin: '0px auto',
        position: 'relative',
        top: '-54px', // To bring input element in to vertically center of screen
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        alignItems="center"
        spacing={2}
        sx={{
          pb: 4,
          height: '144px',
          width: '100%',
          background: (theme) =>
            `radial-gradient(95.01% 400% at 47.58% 356.65%, #7E57C2 26.33%, ${theme.palette.background.default} 82.72%);`,
        }}
      >
        <WisdomLogoIcon
          playAnimation
          sx={{
            fontSize: '4rem',
          }}
        />
        <Typography variant="h6" color="text.secondary">
          What would you like to learn, {firstName}?
        </Typography>
      </Stack>
      <AskOracleInput
        value={question}
        onChange={(e) => {
          setQuestion(e.target.value);
        }}
        containerSxProps={{
          pb: 1,
          maxWidth: '1024px',
          mx: 'auto',
          px: 2.5,
          opacity: isRedirectedFromOnboarding ? 0 : 1,
          animation: isRedirectedFromOnboarding
            ? `${FADE_IN_KEYFRAMES} 0.7s ease-in-out forwards`
            : 'none',
          animationDelay: '1.5s',
        }}
        components={{
          TextField: {
            helperText: undefined,
            inputRef: askOracleInputRef,
          },
        }}
        onSubmit={(searchText: string) => {
          trackWisdomEvents({
            eventName: 'Wisdom - Input Submitted',
            searchText,
            sessionID,
            threadPosition: 0,
          });
        }}
      />
      <Box sx={{ height: '60px' }}>
        <WisdomCapabilities
          sx={{ mt: 2 }}
          onSelect={(prompt) => {
            setQuestion(prompt);

            trackWisdomEvents({
              eventName: 'Wisdom - Use case Clicked',
              searchText: prompt,
              sessionID,
            });

            // Bring the input element in to focus and keep the cursor at the end upon populating prompt
            setTimeout(() => {
              if (askOracleInputRef.current) {
                askOracleInputRef.current.focus();

                const length = prompt.length;
                askOracleInputRef.current.setSelectionRange(length, length);
              }
            }, 0);
          }}
        />
      </Box>
    </Stack>
  );
}
